import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { faGraduationCap } from "@fortawesome/free-solid-svg-icons";
import { faLanguage } from "@fortawesome/free-solid-svg-icons";
import { faCode } from "@fortawesome/free-solid-svg-icons";

import NavBar from "../components/common/navBar";
import Footer from "../components/common/footer";
import Logo from "../components/common/logo";
import Socials from "../components/about/socials";
import SocialsStacks from "../components/about/social-stacks";

import Card from "../components/common/card";
import INFO from "../data/user";
import SEO from "../data/seo";

import "./styles/about.css";

const About = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const currentSEO = SEO.find((item) => item.page === "about");

	return (
		<React.Fragment>
			<Helmet>
				<title>{`Sobre | ${INFO.main.title}`}</title>
				<meta name="description" content={currentSEO.description} />
				<meta
					name="keywords"
					content={currentSEO.keywords.join(", ")}
				/>
			</Helmet>

			<div className="page-content">
				<NavBar active="about" />
				<div className="content-wrapper">
					<div className="about-logo-container">
						<div className="about-logo">
							<Logo width={46} />
						</div>
					</div>

					<div className="about-container">
						<div className="about-main">
							<div className="about-right-side">
								<div className="title about-title">
									{INFO.about.title}
								</div>

								<div className="subtitle about-subtitle">
									{INFO.about.description}
								</div>
							</div>

							<div className="about-left-side">
								<div className="about-image-container">
									<div className="about-image-wrapper">
										<img
											src="about.jpg" // imagem
											alt="about"
											className="about-image"
										/>
									</div>
								</div>

								<br />

								<Card
									icon={faCode}
									title="Tecnologías"
									body={<SocialsStacks />}

								/>

								<br />

								<Card
									icon={faGraduationCap}
									title="Formação Acadêmica"

									body={
										<div className="works-body">
											<div className="work">
												<img
													src="./workLogos/ufcat.png"
													alt="Universidade Federal de Catalão"
													className="work-image"
												/>
												<div className="work-title">Mestrado em Modelagem Computacional</div>
												<div className="work-subtitle">
													Universidade Federal de Catalão
												</div>
												<div className="work-duration"></div>
											</div>

											<div className="work">
												<img
													src="./workLogos/unip.jpg"
													alt="Universidade Unimais"
													className="work-image"
												/>
												<div className="work-title">Bachalerado em Ciências da Computação</div>
												<div className="work-subtitle">
													Universidade Paulista
												</div>
												<div className="work-duration"></div>
											</div>

											<div className="work">
												<img
													src="./workLogos/uniaraxa.png"
													alt="Universidade Federal de Araxa"
													className="work-image" />
												<div className="work-title">Bachalerado em Engenharia</div>
												<div className="work-subtitle">
													Centro Universitário do Planalto de Araxá
												</div>
												<div className="work-duration"></div>
											</div>
										</div>
									}
								/>

								<Card
									icon={faLanguage}
									title="Idiomas"

									body={
										<div className="works-body">

											<div className="work">
												<img
													src="./usa.png"
													alt="Universidade Unimais"
													className="work-image"
												/>
												<div className="work-title">Fluência em Inglês</div>
											</div>

											<div className="work">
												<img
													src="./spain.png"
													alt="Universidade Federal de Catalão"
													className="work-image"
												/>
												<div className="work-title">Fluência em Espanhol Latinoamérica</div>
											</div>

										</div>
									}
								/>

							</div>
						</div>
						<div className="about-socials-mobile">
							<Socials />
						</div>
					</div>
					<div className="page-footer">
						<Footer />
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default About;
